import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { HStack, Skeleton, Stack, Text } from '@chakra-ui/react';
import { AppError } from '@client/components/feedback/AppError';
import { OrderDetailItemsList, OrderDetailItemsListSkeleton, OrderDetailPaymentSection, OrderDetailPaymentSectionSkeleton, OrderDetailSummaryAndShipping, OrderDetailSummaryAndShippingSkeleton, OrderDetailTimeline, OrderDetailTimelineSkeleton, } from '@client/components/orderPage/OrderDetailSections';
import { useApiClient } from '@client/hooks/useApiClient';
import { useMinDuration } from '@client/hooks/useMinDuration';
import { displayFontFamily } from '@client/theme';
import { callApi } from '@client/utils/apiUtils';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
const OrderPageSkeleton = () => (_jsxs(_Fragment, { children: [_jsx(OrderDetailTimelineSkeleton, {}), _jsxs(Stack, { gap: 5, children: [_jsxs(Stack, { gap: 2, children: [_jsx(Skeleton, { height: 10, width: 200 }), _jsx(OrderDetailItemsListSkeleton, {})] }), _jsx(OrderDetailSummaryAndShippingSkeleton, {}), _jsx(OrderDetailPaymentSectionSkeleton, {})] }), _jsx(Skeleton, { width: "100%", height: 55 })] }));
const OrderPageContent = ({ order }) => (_jsxs(_Fragment, { children: [_jsx(OrderDetailTimeline, { timeline: order.timeline, shipments: order.shipments }), _jsxs(Stack, { gap: 5, children: [_jsxs(Stack, { gap: 2, children: [_jsx(Text, { fontFamily: displayFontFamily, fontSize: 26, fontWeight: 500, children: "Item(s)" }), _jsx(OrderDetailItemsList, { items: order.items })] }), _jsx(OrderDetailSummaryAndShipping, { order: order }), order.paymentDetails && (_jsx(OrderDetailPaymentSection, { paymentDetails: order.paymentDetails }))] }), _jsxs(Stack, { gap: 1, fontSize: 20, children: [_jsx(Text, { fontSize: 20, children: "Need help with your order?" }), _jsxs(HStack, { gap: 1, children: [_jsx(Text, { children: "Reach us at" }), _jsx(Text, { fontWeight: 500, children: "support@heirloom.shop" })] })] })] }));
export const OrderPage = () => {
    const apiClient = useApiClient();
    const { shortId } = useParams();
    const { isLoading: authIsLoading } = useAuth0();
    const [searchParams] = useSearchParams();
    const key = searchParams.get('key') ?? '';
    const [isLoading, setIsLoading] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);
    const [error, setError] = useState(null);
    const showSkeleton = useMinDuration(isLoading || authIsLoading);
    const loadOrderData = async () => {
        if (!shortId) {
            return;
        }
        setIsLoading(true);
        const result = await callApi(apiClient.orders.getByShortId({
            params: { shortId },
            query: { key },
        }));
        setIsLoading(false);
        if (result.error !== null) {
            setError(result.error);
        }
        else {
            setOrderDetails(result.data);
        }
    };
    useEffect(() => {
        loadOrderData();
    }, [shortId, key]);
    return (_jsxs(_Fragment, { children: [error && (_jsx(AppError, { title: "Failed to load order", content: error })), !error && (showSkeleton || orderDetails) && (_jsx(Stack, { w: "100%", maxWidth: 600, gap: 8, children: showSkeleton ? (_jsx(OrderPageSkeleton, {})) : (_jsx(OrderPageContent, { order: orderDetails })) }))] }));
};
